import '../../styles.global.css';
import '../../assets/styles/ButtonScroll.module.css';

var styles = {"icon":"wru__ButtonScroll__icon","iconMouse":"wru__ButtonScroll__iconMouse","iconArrow":"wru__ButtonScroll__iconArrow","jumping":"wru__ButtonScroll__jumping","directionUp":"wru__ButtonScroll__directionUp","jumpingUp":"wru__ButtonScroll__jumpingUp","large":"wru__ButtonScroll__large","medium":"wru__ButtonScroll__medium","small":"wru__ButtonScroll__small","correctPosition":"wru__ButtonScroll__correctPosition","isHide":"wru__ButtonScroll__isHide"};

export { styles as default };
//# sourceMappingURL=ButtonScroll.module.scss.js.map
